import React from 'react';
import { Clock, Flame } from 'lucide-react';
import { formatWorkoutDuration } from '../../core/utils/workoutDuration';

/**
 * Compact duration + calories card (mirrors CompactNutrientSummaryCard):
 * totals prominent, then Work / Set rest / Rest after.
 */
export default function WorkoutDurationSummary({ summary, className = '' }) {
  const totalCalories = Number(summary?.totalCalories) || 0;
  const hasDuration = Boolean(summary?.totalLabel);
  const hasCalories = totalCalories > 0;

  if (!hasDuration && !hasCalories) return null;

  const cells = [
    { key: 'work', label: 'Work', seconds: summary?.workSeconds },
    { key: 'setRest', label: 'Set rest', seconds: summary?.setRestSeconds },
    { key: 'restAfter', label: 'Rest after', seconds: summary?.restAfterSeconds },
  ];

  return (
    <div className={`flex flex-col gap-1 shrink-0 ${className}`}>
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-3 border border-gray-200 min-w-[220px]">
        <div className="flex items-stretch justify-between gap-3 mb-2 pb-2 border-b border-gray-300">
          <div className="flex flex-col gap-0.5 min-w-0">
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-orange-500 shrink-0" aria-hidden />
              <span className="text-xs font-medium text-gray-600">Duration</span>
            </div>
            <span className="text-lg font-bold text-gray-900 whitespace-nowrap pl-6">
              {hasDuration ? summary.totalLabel : '0s'}
            </span>
          </div>
          <div className="flex flex-col gap-0.5 items-end text-right shrink-0">
            <div className="flex items-center gap-2">
              <Flame className="w-4 h-4 text-orange-500 shrink-0" aria-hidden />
              <span className="text-xs font-medium text-gray-600">Calories</span>
            </div>
            <span className="text-lg font-bold text-gray-900 whitespace-nowrap">
              {Math.round(totalCalories)}{' '}
              <span className="text-sm font-normal text-gray-600">cal</span>
            </span>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-1.5">
          {cells.map((cell) => (
            <div key={cell.key} className="flex flex-col items-center gap-1">
              <span className="text-xs text-gray-600">{cell.label}</span>
              <span className="text-xs font-semibold text-gray-800">
                {formatWorkoutDuration(cell.seconds, { emptyAsZero: true })}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
